module.exports = __webpack_public_path__ + "static/media/NoForms.878eebdb.png";